// All imports at the top
import { Step } from 'react-joyride';
import { TourType } from '../../../types/onboarding';
import { overviewTourSteps } from './overviewTour';
import { sidebarTourSteps } from './sidebarTour';
import { conversationsTourSteps } from './conversationsTour';
import { agentsTourSteps } from './agentsTour';
import { settingsTourSteps } from './settingsTour';
import { reportsTourSteps } from './reportsTour';
import { recordsTourSteps } from './recordsTour';
import { documentsTourSteps } from './documentsTour';
import { firstLoginTourSteps } from './firstLoginTour';
import { calendarTourSteps } from './calendarTour';
import { schedulerTourSteps } from './schedulerTour';
import { logsTourSteps } from './logsTour';
import { teamsTourSteps } from './teamsTour';

// Export all tour steps
export { overviewTourSteps } from './overviewTour';
export { sidebarTourSteps } from './sidebarTour';
export { conversationsTourSteps } from './conversationsTour';
export { agentsTourSteps } from './agentsTour';
export { settingsTourSteps } from './settingsTour';
export { reportsTourSteps } from './reportsTour';
export { recordsTourSteps } from './recordsTour';
export { documentsTourSteps } from './documentsTour';
export { firstLoginTourSteps } from './firstLoginTour';
export { calendarTourSteps } from './calendarTour';
export { schedulerTourSteps } from './schedulerTour';
export { logsTourSteps } from './logsTour';
export { teamsTourSteps } from './teamsTour';

// Tour steps mapping by tour type

export const tourStepsMap: Record<TourType, Step[]> = {
  [TourType.FIRST_LOGIN]: firstLoginTourSteps,
  [TourType.OVERVIEW]: overviewTourSteps,
  [TourType.SIDEBAR]: sidebarTourSteps,
  [TourType.CONVERSATIONS]: conversationsTourSteps,
  [TourType.AGENTS]: agentsTourSteps,
  [TourType.SETTINGS]: settingsTourSteps,
  [TourType.REPORTS]: reportsTourSteps,
  [TourType.RECORDS]: recordsTourSteps,
  [TourType.DOCUMENTS]: documentsTourSteps,
  [TourType.CALENDAR]: calendarTourSteps,
  [TourType.SCHEDULER]: schedulerTourSteps,
  [TourType.LOGS]: logsTourSteps,
  [TourType.TEAMS]: teamsTourSteps
};

// Helper function to get tour steps by type
export const getTourSteps = (tourType: TourType): Step[] => {
  return tourStepsMap[tourType] || [];
};
